module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ABD")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anchor Bible Dictionary")]), _vm._v(". Edited by David Noel Freedman. 6 vols. New York: Doubleday, 1992")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AnBib")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Analecta Biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANRW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aufstieg und Niedergang der römischen Welt")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AYB")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Yale Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca Ephemeridum Theologicarum Lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ER")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Encyclopedia of Religion")]), _vm._v(". Edited by Mircea Eliade. New York: Macmillan, 1987.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ExpTim")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Goodspeed")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Testament: An American Translation")]), _vm._v(", by Edgar J. Goodspeed")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hart")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Testament: A Translation")]), _vm._v(", by David Bentley Hart")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(". Edited by George A. Buttrick. 4 vols. New York: Abingdon, 1962.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Academy of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Scientific Study of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Knox")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Holy Bible: A Translation From the Latin Vulgate in the Light of the Hebrew and Greek Originals")]), _vm._v(", by Ronald Knox")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moffatt")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Testament: A New Translation")]), _vm._v(", by James Moffatt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MS(S)")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("manuscript(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAB")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NABRE")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Bible Revised Edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NE")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nicomachean Ethics")]), _vm._v(" (Aristotle)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJB")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PIBA")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Proceedings of the Irish Biblical Association")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PRSt")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Perspectives in Religious Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("QD")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Quaestiones Disputatae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue Biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Recherches de science religieuse")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLMS")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLSBS")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Sources for Biblical Study")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLSP")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Seminar Papers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLTT")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Texts and Translations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SCJ")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Christianity and Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTSMS")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTW")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies of the New Testament and Its World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sacra Pagina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studies in Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studia Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TD")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theology Digest")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(". Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theology of the New Testament")]), _vm._v(" (Bultmann)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texts and Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Trinity Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TUGAL")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texte und Untersuchungen zur Geschichte der altchristlichen Literatur")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d8ace6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0